import { render, staticRenderFns } from "./DocumentError.vue?vue&type=template&id=26bd0aeb&scoped=true&"
import script from "./DocumentError.vue?vue&type=script&lang=js&"
export * from "./DocumentError.vue?vue&type=script&lang=js&"
import style0 from "../assets/scss/document_error.scss?vue&type=style&index=0&id=26bd0aeb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26bd0aeb",
  null
  
)

export default component.exports